/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2023-06-26 13:59:52
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2022 Magina Corporation. All rights reserved.
 */
import { post, get } from 'src/api/http';
import * as type from './type';
import { ReturnTableData } from 'src/api/types';
import { ImportProgressData } from 'src/api/types';

class SnmpMgnt {
    getDeviceList (data:type.DeviceInfoParams):Promise<ReturnTableData<type.DeviceInfoRows>> {
        return post('/amr/device-management/device-info/page', data);
    }
    getDcuMeterList (data: type.MeterInfoParams): Promise<ReturnTableData<type.MeterInfoRows>> {
        return post('/amr/device-management/device-data/dcu-meter-data', data);
    }
    getCPUData (data:type.BaseChartParams): Promise<type.MeterInfoData<type.DeviceRateRows>[]> {
        return post('/amr/device-management/device-data/cpu-data', data);
    }
    getRAMData (data:type.BaseChartParams): Promise<type.MeterInfoData<type.DeviceRateRows>[]> {
        return post('/amr/device-management/device-data/ram-data', data);
    }
    getFANData (data:type.BaseChartParams): Promise<type.MeterInfoData<type.DeviceRateRows>[]> {
        return post('/amr/device-management/device-data/dcu-fan-data', data);
    }
    getRSSIData (data: type.MeterChartParams): Promise<type.MeterInfoData<type.MeterInfoRateRows>[]> {
        return post('/amr/device-management/device-data/dcu-rssi-data', data);
    }
    getDelayTimeData (data: type.MeterChartParams): Promise<type.MeterInfoData<type.MeterInfoRateRows>[]> {
        return post('/amr/device-management/device-data/dcu-delay-time-data', data);
    }
    getSucRateData (data: type.MeterChartParams): Promise<type.MeterInfoData<type.MeterInfoRateRows>[]> {
        return post('/amr/device-management/device-data/dcu-success-data', data);
    }
    getDiskRateData (data: type.BaseChartParams): Promise<type.MeterInfoData<type.DeviceRateRows>[]> {
        return post('/amr/device-management/device-data/storage-data', data);
    }
    updateOnlineStatus (deviceIds:string[]):Promise<string> {
        return post('/amr/device-management/device-data/update-device-online', {deviceIds});
    }
    addDeviceInfo (data: type.AddDeviceParam): Promise<string> {
        return post('/amr/device-management/device-info/add', data);
    }
    deleteDevice (deviceIds:string[]): Promise<string> {
        return post('/amr/device-management/device-info/delete', {deviceIds});
    }
    importParse (fileId: string): Promise<string> {
        return post('/amr/device-management/device-info/device-info-import', {fileId});
    }
    getProgress (fileId:string): Promise<ImportProgressData> {
        return get('/amr/device-management/device-info/device-info-progress', {fileId});
    }
    getSchemeInfo (): Promise<type.SchemeInfo> {
        return get('/amr/device-management/device-scheme/scheme-info');
    }
    nextTriggerTime (scheduleConf:string): Promise<string[] | string> {
        return post('/amr/device-management/device-scheme/next-trigger-time', {scheduleConf});
    }
    UpdateJobStatus (data: type.UpdateJobStatusParam): Promise<string> {
        return post('/amr/device-management/device-scheme/update-scheme-job-status', data);
    }
    UpdateJobCron (data: type.UpdateJobCronParam): Promise<string> {
        return post('/amr/device-management/device-scheme/update-scheme-job-cron', data);
    }
    triggerSchemeJob (id: string):Promise<string> {
        return post('/amr/device-management/device-scheme/trigger-scheme-job', {id});
    }
    updateDevice (data: type.UpdateDeviceParam) {
        return post('/amr/device-management/device-info/update', data);
    }
}

export default new SnmpMgnt();
